import * as React from 'react';

import './index.scss';

export interface InfoBannerProps {
	children: React.ReactNode;
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const InfoBanner: React.FunctionComponent<InfoBannerProps> = ({ icon: Icon, children }) => (
	<div className="info_banner">
		<div className="info_banner_icon" aria-hidden="true">
			<Icon />
		</div>
		<p>{children}</p>
	</div>
);

export default InfoBanner;
